﻿import type {Tnt} from "./types";
import {computed, ref, Ref, unref, watch} from "vue";
import {AccessToken} from "./types";
import {DataGroup, DataType, useDataApi} from "./useDataApi";
import {DocumentGroup, DocumentType, useDocumentApi} from "./useDocumentApi";

interface CrudReadOptions {
    skip: number;
    take: number;
}

export enum ReportGroup {
    Pos = "pos",
    Finance = "finance",
    Statistic = "statistic",
    HumanResource = "human-resource",
    BookingCycle = "booking-cycle",
}


export enum ReportType {
    Journal = "journal",
    GobdExport = "gobd-export",
    DsfinvkExport = "dsfinvk-export",
    SaftExport = "saft-export",
    DatevExport = "datev-export",
    TseRegistrationExport = "tse-registration-export",

    AdvancePayment = "advance-payment",
    Voucher = "voucher",
    CreditNote = "credit-note",
    Invoice = "invoice",
    SalesReceiptReport = "sales-receipt-report",

    SaleStatistics = "sale-statistics",
    ReservationDemand = "reservation-demand",
    Cancellations = "cancellations",
    Retoure = "retoure",
    Turnover = "turnover",

    StaffPurchase = "staff-purchase",
    TimeRegistration = "time-registration",
    LocationSafeBalance = "location-safe-balance",
    CashBalanceOverview = "cash-balance-overview",
    TurnoverPerProductLine ="turnover-per-product-line",
    TurnoverPerOperator ="turnover-per-operator",
    TurnoverPerProductLineAndOperator ="turnover-per-product-line-and-operator",
    TurnoverPerHourOfSale ="turnover-per-hour-of-sale",
    TurnoverPerShop ="turnover-per-shop",
    ParametrizedTurnover="parametrized-turnover",
    StoresEndOfDay ="stores-end-of-day",
    FiscalTransmissionFailures ="fiscal-transmission-failures",
}

export const useReportApi = (
    reportGroup: Ref<ReportGroup>,
    reportType: Ref<ReportType>,
    accessToken: AccessToken
) => {

    let mateApi: any;
    const tenantOid = ref(0);

    watch(reportType, rt => {
        switch (rt) {
            case ReportType.AdvancePayment:
            case ReportType.Voucher:
            case ReportType.CreditNote:
            case ReportType.Invoice:
            case ReportType.SalesReceiptReport:
            case ReportType.SaleStatistics:
            case ReportType.ReservationDemand:
            case ReportType.Cancellations:
            case ReportType.Retoure:
            case ReportType.Turnover:
            case ReportType.TimeRegistration:
            case ReportType.CashBalanceOverview:
            case ReportType.TurnoverPerProductLine:
            case ReportType.TurnoverPerOperator:
            case ReportType.TurnoverPerProductLineAndOperator:
            case ReportType.TurnoverPerHourOfSale:
            case ReportType.ParametrizedTurnover:
                const locationApi = useDataApi(DataGroup.PosOperating, DataType.Location, tenantOid, accessToken);
                mateApi = {
                    ...locationApi,
                    readList: (query:any, options:any) =>
                        locationApi
                            .readList(query, options)
                            .then((list: any[]) => {
                                if (options?.skip === 0 && !query?.LocationRoleOid && !(query?.LocationRoleOids?.length>0)) {
                                    list.splice(0, 0, {Name: "@@Common.AllLocations"});
                                }
                                return list;
                            })
                }
                break;
            case ReportType.LocationSafeBalance:
                 const locationApi2 = useDataApi(DataGroup.PosOperating, DataType.Location, tenantOid, accessToken);
                 mateApi = {
                     ...locationApi2,
                     readList: (query:any, options:any) =>
                         locationApi2
                             .readList(query, options)
                 }
                 break;
            case ReportType.StaffPurchase:
                const operatorApi = useDataApi(DataGroup.PosOperating, DataType.Operator, tenantOid, accessToken);
                mateApi = {
                    ...operatorApi,
                    readList: (query:any, options:any) =>
                        operatorApi
                            .readList(query, options)
                            .then((list: any[]) => {
                                if (options?.skip === 0 && !query?.Number && !query?.FirstName && !query?.LastName) {
                                    list.splice(0, 0, {Name: "@@Common.All"});
                                }
                                return list;
                            })
                }
                break;
            case ReportType.Journal:
                mateApi = useDocumentApi(DocumentGroup.SalesPeriod, DocumentType.DailyOpening, accessToken);
                break;
            case ReportType.StoresEndOfDay:
            case ReportType.TurnoverPerShop:
                mateApi = useDataApi(DataGroup.Tenancy, DataType.Tenant, 0, accessToken);
                break;
            default:
                return undefined;
        }

    }, {immediate: true})

    const key = (entity: any) => mateApi?.key(entity);
    const readList = <TEntity = any>(params: any, options: CrudReadOptions) => mateApi?.readList(params, options);

    return {
        key,
        readList
    }

}